// Use the global AmazonCognitoIdentity object
declare const AmazonCognitoIdentity: any;

const { CognitoUserPool, CognitoUser, AuthenticationDetails } = AmazonCognitoIdentity;

interface CognitoConfig {
    UserPoolId: string;
    ClientId: string;
}

interface FileInfo {
    key: string;
    size: number;
    lastModified: Date;
    contentType: string;
    description: string;
}

interface SignedUrlResponse {
    url: string;
}

// AWS Cognito configuration
const poolData: CognitoConfig = {
    UserPoolId: 'us-east-1_I0J9kFO8I',
    ClientId: 'kotkak747u6rteq69uop2vksa'
};

const userPool = new CognitoUserPool(poolData);
let currentUser: any = null;
let pendingUserAttributes: any = null;
const API_URL = 'https://download.app.smartux.com';

// DOM Elements
const loginForm = document.getElementById('login') as HTMLFormElement;
const loginSection = document.getElementById('loginForm') as HTMLDivElement;
const newPasswordForm = document.getElementById('newPasswordForm') as HTMLDivElement;
const setNewPasswordForm = document.getElementById('setNewPassword') as HTMLFormElement;
const downloadSection = document.getElementById('downloadSection') as HTMLDivElement;
const fileList = document.getElementById('fileList') as HTMLDivElement;
const logoutBtn = document.getElementById('logoutBtn') as HTMLButtonElement;
const passwordError = document.getElementById('passwordError') as HTMLDivElement;

// Login handler
loginForm.addEventListener('submit', async (e: Event) => {
    e.preventDefault();
    const email = (document.getElementById('email') as HTMLInputElement).value;
    const password = (document.getElementById('password') as HTMLInputElement).value;

    const authenticationData = {
        Username: email,
        Password: password
    };

    const authenticationDetails = new AuthenticationDetails(authenticationData);
    const userData = {
        Username: email,
        Pool: userPool
    };

    const cognitoUser = new CognitoUser(userData);
    currentUser = cognitoUser;

    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: async (session: any) => {
            const token = session.getIdToken().getJwtToken();
            localStorage.setItem('token', token);
            showDownloadSection();
            await loadFiles();
        },
        onFailure: (err: Error) => {
            alert('Error: ' + err.message || JSON.stringify(err));
        },
        newPasswordRequired: (userAttributes: any) => {
            // Delete unwanted attributes before setting new password
            delete userAttributes.email_verified;
            delete userAttributes.phone_number_verified;
            delete userAttributes.email;  // Remove email as it's already set
            delete userAttributes.sub;    // Remove sub as it's immutable
            pendingUserAttributes = userAttributes;
            showNewPasswordForm();
        }
    });
});

// New Password Form Handler
setNewPasswordForm.addEventListener('submit', (e: Event) => {
    e.preventDefault();
    const newPassword = (document.getElementById('newPassword') as HTMLInputElement).value;
    const confirmPassword = (document.getElementById('confirmPassword') as HTMLInputElement).value;

    if (newPassword !== confirmPassword) {
        passwordError.classList.remove('hidden');
        return;
    }

    passwordError.classList.add('hidden');

    if (currentUser && pendingUserAttributes) {
        currentUser.completeNewPasswordChallenge(newPassword, pendingUserAttributes, {
            onSuccess: async (session: any) => {
                const token = session.getIdToken().getJwtToken();
                localStorage.setItem('token', token);
                hideNewPasswordForm();
                showDownloadSection();
                await loadFiles();
            },
            onFailure: (err: Error) => {
                alert('Error setting new password: ' + err.message || JSON.stringify(err));
            }
        });
    }
});

// Load files from S3
async function loadFiles(): Promise<void> {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/files`, {
            headers: {
                'Authorization': token || ''
            }
        });
        const files = await response.json();
        displayFiles(files);
    } catch (error) {
        console.error('Error loading files:', error);
        alert('Error loading files. Please try again.');
    }
}

// Display files in the UI
function displayFiles(files: { files: FileInfo[] }): void {
    fileList.innerHTML = '';
    files.files.forEach(file => {
        const fileDiv = document.createElement('div');
        fileDiv.className = 'p-4 border rounded hover:bg-gray-50';
        
        const fileInfo = document.createElement('div');
        fileInfo.className = 'flex justify-between items-start';
        
        const mainInfo = document.createElement('div');
        mainInfo.innerHTML = `
            <div class="font-medium">${file.key}</div>
            <div class="text-sm text-gray-500">
                ${formatFileSize(file.size)} • ${file.contentType}
            </div>
            ${file.description ? `
                <div class="mt-2 text-sm text-gray-600">
                    ${file.description}
                </div>
            ` : ''}
        `;

        const downloadButton = document.createElement('button');
        downloadButton.className = 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 ml-4';
        downloadButton.textContent = 'Download';
        downloadButton.onclick = () => downloadFile(file.key);

        fileInfo.appendChild(mainInfo);
        fileInfo.appendChild(downloadButton);
        fileDiv.appendChild(fileInfo);
        fileList.appendChild(fileDiv);
    });
}

// Generate and trigger download
async function downloadFile(fileKey: string): Promise<void> {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/download/${fileKey}`, {
            headers: {
                'Authorization': token || ''
            }
        });
        const data = await response.json() as SignedUrlResponse;
        window.location.href = data.url;
    } catch (error) {
        console.error('Error downloading file:', error);
        alert('Error downloading file. Please try again.');
    }
}

// Utility function to format file size
function formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// Show/Hide UI sections
function showNewPasswordForm(): void {
    loginSection.classList.add('hidden');
    newPasswordForm.classList.remove('hidden');
    downloadSection.classList.add('hidden');
}

function hideNewPasswordForm(): void {
    newPasswordForm.classList.add('hidden');
}

function showDownloadSection(): void {
    loginSection.classList.add('hidden');
    newPasswordForm.classList.add('hidden');
    downloadSection.classList.remove('hidden');
}

// Logout handler
logoutBtn.addEventListener('click', () => {
    if (currentUser) {
        currentUser.signOut();
        currentUser = null;
        pendingUserAttributes = null;
        localStorage.removeItem('token');
        loginSection.classList.remove('hidden');
        newPasswordForm.classList.add('hidden');
        downloadSection.classList.add('hidden');
        loginForm.reset();
        setNewPasswordForm.reset();
    }
});
